import { render } from "./App.vue?vue&type=template&id=08962b8f&lang=pug"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=08962b8f&lang=scss"

import exportComponent from "/Users/jon.bloom/Documents/Clients/Freshwater/ise-ds-awards-2022-microsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__